/// <reference path="appbase.ts" />
/// <reference path="../classes/LotInfoBox.ts" />

namespace TerminalApp {

    class App_Item_Info extends AppBase {
        bound = false;
        currentItemId: string = "";

        button_add_barcode = document.getElementById("pi_add_barcode");
        button_add_additional_barcode = document.getElementById("pi_add_additional_barcode");
        button_search_ean = document.getElementById("pi_search_ean");
        button_search_item = document.getElementById("pi_search_item");
        button_add_item = document.getElementById("pi_add_item");
        pi_scan_placeholder = document.getElementById("pi_scan_placeholder");
        pi_item_info = document.getElementById("pi_item_info");
        pi_weight = document.getElementById("pi_weight") as HTMLInputElement;
        pi_length = document.getElementById("pi_length") as HTMLInputElement;
        pi_height = document.getElementById("pi_height") as HTMLInputElement;
        pi_width = document.getElementById("pi_width") as HTMLInputElement;
        pi_normal_price = document.getElementById("pi_normal_price") as HTMLInputElement;
        pi_sales_price = document.getElementById("pi_sales_price") as HTMLInputElement;

        bcAssistant: BarcodeInputAssistant;
        printAssistant: BarcodePrintAssistant;
        currentItem: SP.ItemInfo;
        lots: SP.StockingLotInfo[];
        info_container: HTMLElement;
        item_container: HTMLElement;
        placement_container: HTMLElement;
        barcode_container: HTMLElement;
        additional_barcode_container: HTMLElement;
        constructor() {
            super("app_item_info");
            this.bcAssistant = new BarcodeInputAssistant();
            this.printAssistant = new BarcodePrintAssistant();
            this.container.appendChild(this.bcAssistant.container);
            this.container.appendChild(this.printAssistant.container);

            this.button_add_barcode.addEventListener("click", () => {
                this.bcAssistant.open(false, async (bc, colli_qty) => {
                    if (this.currentItem != null) {
                        if (this.currentItem.barcodes.indexOf(bc) == -1) {
                            this.currentItem.barcodes.push(bc);
                            await SP.post("/api/v1/item/import", [{
                                id: this.currentItem.id,
                                barcodes: this.currentItem.barcodes
                            }]);
                            this.addBarcode(bc, false, colli_qty);
                        }
                    }

                });
            });


            this.button_add_additional_barcode.addEventListener("click", () => {
                this.bcAssistant.open(true, async (bc, colli_qty) => {
                    if (this.currentItem != null) {
                        this.currentItem.additionalBarcodes[bc] = colli_qty;
                        await SP.post("/api/v1/item/import", [{
                            id: this.currentItem.id,
                            additionalBarcodes: this.currentItem.additionalBarcodes
                        }]);
                        this.addBarcode(bc, true, colli_qty);
                    }

                });
            });

            this.info_container = document.getElementById("pi_item_info");
            this.item_container = this.info_container.querySelector(".item_container");
            this.placement_container = this.info_container.querySelector(".placement_container");
            this.barcode_container = this.info_container.querySelector("#pi_barcode_container");
            this.additional_barcode_container = this.info_container.querySelector("#pi_additional_barcode_container");

            this.pi_weight.addEventListener("change", async () => {
                await SP.post("/api/v1/item/import", [
                    {
                        "id": this.currentItem.id,
                        "weight": parseInt(this.pi_weight.value)
                    }
                ]);
            });

            this.pi_length.addEventListener("change", async () => {
                await SP.post("/api/v1/item/import", [
                    {
                        "id": this.currentItem.id,
                        "debth": parseInt(this.pi_length.value)
                    }
                ]);
            });

            this.pi_height.addEventListener("change", async () => {
                await SP.post("/api/v1/item/import", [
                    {
                        "id": this.currentItem.id,
                        "height": parseInt(this.pi_height.value)
                    }
                ]);
            });

            this.pi_width.addEventListener("change", async () => {
                await SP.post("/api/v1/item/import", [
                    {
                        "id": this.currentItem.id,
                        "width": parseInt(this.pi_width.value)
                    }
                ]);
            });

            this.button_search_item.addEventListener("click", () => {
                itemSearchAssistant.open(null, "", false, (item) => {
                    this.selectItem(item);
                });
            });

            this.button_search_ean.addEventListener("click", () => {
                itemSearchAssistant.open(null, "", true, (item) => {
                    this.selectItem(item);
                });
            });

            this.button_add_item.addEventListener("click", () => {
                addItemAssistant.open((itemId) => {
                    this.selectItemId(itemId);
                });
            });
        }

        reset() {
            this.clearData();
            this.currentItemId = "";
            this.pi_scan_placeholder.style.display = "block";
            this.pi_item_info.style.display = "none";
        }

        async onOpen() {
            this.reset();

            await this.selectItemId(SP.getHash("itemId"));
            //bind events and groups
            if (!this.bound) {
                this.bound = true;
                barcodeListener.on("sp", this.scanPlacement, this);
                barcodeListener.on(null, this.scanBarcode, this);
            }
        }
        scanPlacement(placementId: string) {
            throw new Error("Method not implemented.");
        }

        async setPreferredPlacement(placementId: number) {
            if (this.currentItem) {
                var newId = this.currentItem.preferredStockPlacementId == placementId ? 0 : placementId;
                StartLoading();
                var result = await SP.post<any>("/api/v1/item/import", [{
                    id: this.currentItem.id,
                    preferredStockPlacementId: newId
                }]);
                StopLoading();
                //this.reload();
                this.currentItem.preferredStockPlacementId = newId;
                return newId != 0;

            }
            return null;
        }

        async onClose() {
            //unbind events and groups
            if (this.bound) {
                this.bound = false;
                barcodeListener.off("sp", this.scanPlacement);
                barcodeListener.off(null, this.scanBarcode);
            }

            itemSearchAssistant.close();
            this.bcAssistant.clear();
            addItemAssistant.close();
            this.reset();
        }

        async selectItemId(itemId: string) {
            if (!itemId) return;
            StartLoading();
            var data = (await SP.Data.Item.getWarehouseItemInfo(itemId)) as SP.ItemInfo;
            await this.selectItem(data);
            StopLoading();
        }

        async selectItem(item: SP.ItemInfo) {

            if (this.currentItemId != item.id) {
                StartLoading();
                this.currentItem = item;
                this.currentItemId = item.id;
                ignoreHashChange = true;
                SP.setManyHash({ "itemId": item.id });
                this.lots = await SP.Data.StockingLot.getItemStockingLotInfos(item.id, false);
                this.render();
                this.pi_scan_placeholder.style.display = "none";
                this.pi_item_info.style.display = "block";

                this.pi_weight.value = item.weight.toString();
                this.pi_length.value = item.debth.toString();
                this.pi_height.value = item.height.toString();
                this.pi_width.value = item.width.toString();
                this.pi_normal_price.value = item.normalPrice.toFixed(2);
                this.pi_sales_price.value = item.salePrice.toFixed(2);

                await StopLoading();
                ignoreHashChange = false;
            }
        }

        reload() {
            let id = this.currentItemId;
            this.currentItemId = "";
            this.selectItemId(id);
        }

        render() {
            let item = this.currentItem;

            this.placement_container.innerHTML = "";
            this.barcode_container.innerHTML = "";
            this.additional_barcode_container.innerHTML = "";

            //render item
            this.item_container.innerHTML = `
                <div class="item_box1" style="width:97%; margin:auto;margin-bottom:10px;">
                    <div class="inner">
                        <img class="image" src="${item.imageUrl}">
                        <div class="text">
                            <span class="sku">${item.sku}</span>
                            <span class="description">${item.description}</span>
                            <span class="barcode">${item.barcodes.join(", ")}</span>
                            <span class="infos">
                                <span class="label badge" id="ass_pending_status">Stock<br><span>${item.totalCombined}</span></span>
                                <span class="label badge" id="ass_pending_status">Incomming<br><span>${item.incommingCombined}</span></span>
                                <span class="label badge" id="ass_pending_status">Sold<br><span>${item.reservedCombined}</span></span>
                            </span>
                        </div>
                    </div>
                </div>
            `;


            this.item_container.querySelector(".image").addEventListener("click", (e) => {
                itemShortcutAssistant.open_with_info(item);
                e.preventDefault();
                e.stopPropagation();
            });

            //render locations
            let locations = {} as any;

            console.log("item", item);
            if (item.preferredStockPlacementData) {
                locations[item.preferredStockPlacementData] = { id: item.preferredStockPlacementId, amt: 0 };
            }

            this.lots.forEach(l => {
                if (l.placementQuantity > 0) {
                    if (!locations[l.stockPlacementData]) locations[l.stockPlacementData] = { id: l.stockPlacementId, amt: l.placementQuantity };
                    else locations[l.stockPlacementData].amt += l.placementQuantity;
                }
            });

            for (let location in locations) {
                let t = new PlacementInfoBox(location, true, this.currentItem);
                let placement_id = locations[location].id;
                let amt = locations[location].amt;
                let loc = document.createElement("div");
                let preferred = location == item.preferredStockPlacementData;
                loc.classList.add("placement_header");
                loc.appendChild(t.container);

                let star = document.createElement("span");
                star.classList.add("preferred");
                if (preferred) star.classList.add("selected");
                star.innerHTML = preferred ? `<i class="fa-solid fa-star"></i>` : `<i class="fa-regular fa-star"></i>`;
                loc.appendChild(star);

                star.addEventListener("click", async () => {
                    let pref = await this.setPreferredPlacement(placement_id);
                    let curr = this.placement_container.querySelector(".preferred.selected");
                    if (curr) {
                        curr.innerHTML = `<i class="fa-regular fa-star"></i>`;
                        curr.classList.remove("selected");

                    }
                    if (pref) {
                        star.innerHTML = pref ? `<i class="fa-solid fa-star"></i>` : `<i class="fa-regular fa-star"></i>`;
                        star.classList.add("selected");
                    }

                });

                let amt_label = document.createElement("span");
                amt_label.classList.add("label");
                amt_label.innerHTML = amt;
                loc.appendChild(amt_label);

                this.placement_container.appendChild(loc);
            }

            //5711614905500
            //https://localhost:5001/terminal/#app=app_item_info&itemId=2bc76902-5f6d-43b7-816e-0002325442e3

            item.barcodes.forEach(b => {
                this.addBarcode(b, false, 1);
            });

            for (var bc in item.additionalBarcodes) {
                this.addBarcode(bc, true, item.additionalBarcodes[bc]);
            }

        }

        clearData() {
            //clear previous data
            // this.pi_item_info.innerHTML = "";
        }

        addBarcode(bc: string, additional: boolean, colli_qty:number) {

            let bar = document.createElement("div");
            bar.classList.add("barcode");
            bar.innerHTML = bc;

            if (additional) {
                var delete_btn = document.createElement("span");
                delete_btn.classList.add("colli");
                delete_btn.innerHTML = "Colli " + colli_qty.toString();
                bar.appendChild(delete_btn);
            }


            var delete_btn = document.createElement("span");
            delete_btn.classList.add("delete");
            delete_btn.innerHTML = `<i class="fa-solid fa-trash"></i></span>`;
            bar.appendChild(delete_btn);

            delete_btn.addEventListener("click", async () => {
                if (await SP.confirmX("Delete Barcode")) {
                    if (additional) {

                        console.log("delete additional: " + bc);
                        delete this.currentItem.additionalBarcodes[bc];
                        await SP.post("/api/v1/item/import", [{
                            id: this.currentItem.id,
                            additionalBarcodes: this.currentItem.additionalBarcodes
                        }]);
                    }
                    else {
                        console.log("delete additional: " + bc);
                        this.currentItem.barcodes.splice(this.currentItem.barcodes.indexOf(bc), 1);
                        await SP.post("/api/v1/item/import", [{
                            id: this.currentItem.id,
                            barcodes: this.currentItem.barcodes
                        }]);
                    }
                    bar.remove();
                }
            });

            var print_btn = document.createElement("span");
            print_btn.classList.add("print");
            print_btn.innerHTML = `<i class="fa-solid fa-print"></i></span>`;
            bar.appendChild(print_btn);

            print_btn.addEventListener("click", async () => {
                this.printAssistant.open(this.currentItem.customerId, this.currentItemId, bc, colli_qty);
            });

            if (additional) {
                this.additional_barcode_container.appendChild(bar);

            }
            else {
                this.barcode_container.appendChild(bar);
            }
        }

        async scanBarcode(barcode: string) {
            //if (this.bcAssistant.bound) return;
            //auto search
            itemSearchAssistant.open(null, barcode, false, (i) => {
                this.selectItem(i);
            });
        }

    }
    RegisterApp("app_item_info", App_Item_Info);
}
